import { render, staticRenderFns } from "./webPayRejList.vue?vue&type=template&id=93f1887c&scoped=true"
import script from "./webPayRejList.vue?vue&type=script&lang=js"
export * from "./webPayRejList.vue?vue&type=script&lang=js"
import style0 from "./webPayRejList.vue?vue&type=style&index=0&id=93f1887c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f1887c",
  null
  
)

export default component.exports